<div class="modal-header">
    <h3 class="modal-title">Customize</h3>
</div>

<div class="panel-body" id="panelbody">
    <div class="panel panel-white">
        <tax-rates-editor
            #taxRatesEditor
            [isAlwaysEdit]="true"
            [canAdd]="alterable"
            [canEdit]="true"
            [canDelete]="alterable"
            [lockedFields]="alterable ? [] : lockedFields"
            [description]="details.description"
            [shortCode]="details.shortCode"
            [taxRates]="details.taxRates">
        </tax-rates-editor>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default btn-o btn-wide" (click)="cancel()">Cancel</button>
    <button [disabled]="!isValid()" type="submit" class="btn btn-primary btn-o btn-wide" (click)="ok()">Ok</button>
</div>
